export class LoginCredentials {
  license;
  username;
  password;
}
